import RelationshipAddContactInfoContainer from './RelationshipAddContactInfoContainer';

export default RelationshipAddContactInfoContainer;